import FantasyLabsService from '../../services/fantasyLabsService';
import * as actionTypes from '../../constants/actionTypes';
import moment from 'moment-timezone';

export function getGamelogs(playerId, sport, propsDate, sessionId) {
    return dispatch => {
        dispatch(gamelogFetching());

        const timeFormat = 'YYYY-MM-DDTHH:mm';

        let showMonths = -1;

        if (sport === 'mlb' && (moment().month() === 2 || moment().month() === 3)) {
            showMonths = -6;
        }

        const fromDate = moment(propsDate)
            .add(showMonths, 'M')
            .format(timeFormat);

        const toDate = moment(propsDate).format(timeFormat);

        const service = new FantasyLabsService();
        service.getGamelogs(
            playerId,
            sport,
            fromDate,
            toDate,
            sessionId,
            err => dispatch(gamelogFailed(err)),
            json => dispatch(gamelogSuccess(json))
        );
    };
}

function gamelogFetching() {
    return {
        type: actionTypes.GAMELOGS_FETCHING
    };
}

function gamelogSuccess(json) {
    return {
        type: actionTypes.GAMELOGS_SUCCESS,
        results: json.gamelogs === null ? [] : json.gamelogs
    };
}

function gamelogFailed(err) {
    return {
        type: actionTypes.GAMELOGS_FAILED,
        errorMessage: err
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/gamelogs.js